import { ThomsonReutersCallbackPayloadState } from '@common/neo.tax';

import { env } from '@neo.tax/shared/utils';

const THOMSON_REUTERS_REDIRECT = `${env.REACT_APP_BACKEND_BASE_URL}/third-party-tokens/thomson-reuters/callback`;

export const getThomsonReutersAuthUrl = (
  thomsonReutersConsumerKey: string,
  {
    action,
    binderId,
    companyId,
    errorRedirectUrl,
    successRedirectUrl,
    taxYear,
    userId,
  }: ThomsonReutersCallbackPayloadState,
): string => {
  const state = encodeURIComponent(
    JSON.stringify({
      action,
      binderId,
      companyId,
      errorRedirectUrl,
      successRedirectUrl,
      taxYear,
      userId,
    }),
  );
  const redirectUri = encodeURIComponent(THOMSON_REUTERS_REDIRECT);
  return `${env.REACT_APP_THOMSON_REUTERS_API_URL}/oauth2/v1/authorize?client_id=${thomsonReutersConsumerKey}&state=${state}&response_type=code&redirect_url=${redirectUri}`;
};
